// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"67d49640","247":"2ab9eea3","453":"cfc8f570","627":"545ae525","653":"2ea01de8","834":"ae977214","867":"5e947053","923":"94a68ccc","938":"ff46dc43"}[chunkId] + ".chunk.js";
};